import React from 'react';

const Contact = () => {
    return (
        <div className="contact" id="contact">
            <div className="footer-left">
                <h2>Achievements</h2>
                <ul>
                    <h4><li>Certified AWS Cloud Practitioner with foundational AWS knowledge</li></h4>
                    <h4><li>Finalist in Dark Pattern Buster Hackathon at BHU (IIT) Varanasi</li></h4>
                    <h4><li>Finalist In Intel OneAPI Hackathon</li></h4>
                    <h4><li>Finalist SkillEd Hackathon 2024-25</li></h4>
                    <h4><li>Finalist Appathon 2025 at Sona College Of Technology</li></h4>
                    <h4><li>Secured a global rank of 1197 in TCS CodeVita Season 11</li></h4>
                    <h4><li>Winner of Smart India Internal Hackathon 2024</li></h4>
                    <h4><li>Semi Finalist Manas Codeathon 2023</li></h4>
                </ul>
            </div>
            <div className="footer-right">
                <h3>"I'm Interested About"</h3>
                <div className="interests">
                    <p>Frontend Development</p>
                    <p>Backend Development</p>
                    <p>AI Tools</p>
                    <p>DevOps</p>
                    <p>App Development</p>
                    <p>UI / UX Design</p>
                    <p>Software Development</p>
                    <p>Generative AI</p>
                    <p>Machine Learning</p>
                    <p>Full-Stack Development</p>
                    <p>Cloud Engineering</p>
                </div>
                <hr />
                <h3>Wanna Hire Me ? <span><a href="mailto:mailtogarul@gmail.com">Mail</a></span></h3>
            </div>
        </div>
    );
};

export default Contact;
